/**
 * According to our research (see https://github.com/Yoast/research/wiki/Sentence-length-Hebrew) sentences in Hebrew
 * tend to be shorter than sentences in English. One article particularly advises to use no more than 10-12 words per sentence.
 */
export default {
	sentenceLength: {
		recommendedWordCount: 15,
	},
};
